module.exports = __webpack_public_path__ + "img/newicon4.fc01a4c8.svg";